/**
 * Probe for the name-homonym hint (`useBeneficiaryNameHomonymCheck`): `rows: 5` so the response carries
 * the matched beneficiaries' ids, needed to exclude the record currently being edited by identity — a
 * `rows: 1` probe would only ever surface a count, which cannot distinguish the edited record itself
 * from a real homonym once its name has changed.
 * The probe stays scoped to the current facility through `facilityIds`.
 */
class SearchBeneficiaryHomonyms {
	constructor(
		public readonly accountId: number,
		public readonly facilityId: number,
		public readonly lastName: string,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const queryParams = new URLSearchParams({
			search: this.lastName,
			rows: '5',
			facilityIds: String(this.facilityId),
		});

		return queryParams.toString();
	}
}

export default SearchBeneficiaryHomonyms;
